import { DynamicSectionEvents, SectionTypes } from 'src/interfaces';

export enum CodJourney {
  CUSTOMER_ENTERS_DRIVE_THRU = 'Customer enters drive-thru',
  ORDER_IS_MADE = 'Order is made',
  PURCHASE_IS_CONFIRMED = 'Purchase is confirmed',
}

export const OrderStates = [
  CodJourney.CUSTOMER_ENTERS_DRIVE_THRU,
  CodJourney.ORDER_IS_MADE,
  CodJourney.PURCHASE_IS_CONFIRMED,
];

export enum SectionJourney {
  DEFAULT = 'DEFAULT',
  SECTION_ROTATION = 'Screen Rotation',
  TAKE_OVER = 'Take Over',
}

export type AssemblyJourneys = CodJourney | SectionJourney;

export const ASSEMBLY_JOURNEY_SECTION_EVENTS_MAP: {
  [key in AssemblyJourneys]?: {
    [key in SectionTypes]?: string;
  };
} = {
  [CodJourney.CUSTOMER_ENTERS_DRIVE_THRU]: {
    [SectionTypes.THANK_YOU]: DynamicSectionEvents.COD_THANK_YOU_CLOSE,
  },
  [CodJourney.ORDER_IS_MADE]: {
    [SectionTypes.COD]: DynamicSectionEvents.COD_ORDER_OPEN,
    [SectionTypes.DY]: DynamicSectionEvents.DY_SUGGESTIONS_OPEN,
    [SectionTypes.THANK_YOU]: DynamicSectionEvents.COD_THANK_YOU_CLOSE,
  },
  [CodJourney.PURCHASE_IS_CONFIRMED]: {
    [SectionTypes.CONFIRMATION]: DynamicSectionEvents.COD_CONFIRMATION_OPEN,
    [SectionTypes.DY]: DynamicSectionEvents.DY_SUGGESTIONS_CLOSE,
    [SectionTypes.THANK_YOU]: DynamicSectionEvents.COD_THANK_YOU_OPEN,
  },
  [SectionJourney.SECTION_ROTATION]: {
    [SectionTypes.SECTION_ROTATION]: DynamicSectionEvents.SECTION_TIMER,
  },
  [SectionJourney.TAKE_OVER]: {
    [SectionTypes.TAKE_OVER]: DynamicSectionEvents.LAYOUT_TIMER,
  },
};

export const DefaultRotationValues = {
  [DynamicSectionEvents.DEFAULT]: 10,
  [DynamicSectionEvents.SECTION_TIMER]: 5,
  [DynamicSectionEvents.LAYOUT_TIMER]: 5,
};

export enum DynamicHighlight {
  DEFAULT = 0,
  OUTDOOR = 1,
  SECTION_ROTATION = 2,
  TAKE_OVER = 3,
}

export const mapDynamicHighlightToSectionJourney = {
  [DynamicHighlight.DEFAULT]: SectionJourney.DEFAULT,
  [DynamicHighlight.OUTDOOR]: {
    [CodJourney.CUSTOMER_ENTERS_DRIVE_THRU]:
      CodJourney.CUSTOMER_ENTERS_DRIVE_THRU,
    [CodJourney.ORDER_IS_MADE]: CodJourney.ORDER_IS_MADE,
    [CodJourney.PURCHASE_IS_CONFIRMED]: CodJourney.PURCHASE_IS_CONFIRMED,
  },
  [DynamicHighlight.SECTION_ROTATION]: SectionJourney.SECTION_ROTATION,
  [DynamicHighlight.TAKE_OVER]: SectionJourney.TAKE_OVER,
};
